document.addEventListener('DOMContentLoaded', () => {
  const mobileBreakpoint = 850;

  function isMobile() {
    return window.innerWidth < mobileBreakpoint;
  }

  // Get current URL path
  const path = window.location.pathname;

  // Only proceed if URL contains 'checkout' 
  if (!path.includes('checkout')) {
    return;  // Exit early: disable toggle on other pages
  }

  const siteNav = document.querySelector('.site-nav');
  if (!siteNav) return;

  const topLevelCollectionsLink = [...siteNav.children].find(el =>
    el.tagName === 'A' && el.getAttribute('href') === '/'
  );
  if (!topLevelCollectionsLink) return;

  function getSubmenuItems() {
    const submenuItems = [];
    let sibling = topLevelCollectionsLink.nextElementSibling;
    while (sibling && sibling.tagName === 'A' && sibling.getAttribute('href') !== '/pages/ss25-about') {
      submenuItems.push(sibling);
      sibling = sibling.nextElementSibling;
    }
    return submenuItems;
  }

  let submenuVisible = false;

  topLevelCollectionsLink.addEventListener('click', (e) => {
    if (!isMobile()) return;

    if (e.currentTarget !== topLevelCollectionsLink) {
      return;
    }

    e.preventDefault();

    const submenuItems = getSubmenuItems();

    if (!submenuVisible) {
      submenuItems.forEach(link => link.style.display = 'block');
      siteNav.classList.add('open');
      topLevelCollectionsLink.classList.add('open');
      submenuVisible = true;
    } else {
      submenuItems.forEach(link => link.style.display = 'none');
      siteNav.classList.remove('open');
      topLevelCollectionsLink.classList.remove('open');
      submenuVisible = false;
    }
  });

  // Hide submenu by default on mobile load
  if (isMobile()) {
    getSubmenuItems().forEach(link => link.style.display = 'none');
  }

  // Close submenu when clicking outside
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;
    if (!siteNav.contains(e.target)) {
      getSubmenuItems().forEach(link => link.style.display = 'none');
      siteNav.classList.remove('open');
      topLevelCollectionsLink.classList.remove('open');
      submenuVisible = false;
    }
  });

  // Reset on window resize
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      getSubmenuItems().forEach(link => link.style.display = '');
      siteNav.classList.remove('open');
      topLevelCollectionsLink.classList.remove('open');
      submenuVisible = false;
    } else {
      getSubmenuItems().forEach(link => link.style.display = 'none');
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const siteNav = document.querySelector('.site-nav');
  if (!siteNav) return;

  const productsParentLink = siteNav.querySelector('a.parent-active');

  if (!productsParentLink) return;

  const childLinks = productsParentLink.nextElementSibling?.querySelectorAll('a') || [];

  // If any child is active, mark parent active too (but don't open dropdown automatically)
  const childActive = Array.from(childLinks).some(link => link.classList.contains('active'));
  if (childActive) {
    productsParentLink.classList.add('active');
  } else {
    productsParentLink.classList.remove('active');
  }

  // Toggle dropdown open/close on clicking the Products link
  productsParentLink.addEventListener('click', (e) => {
    e.preventDefault();  // prevent navigation if Products has href

    siteNav.classList.toggle('open');
  });

  // Optional: close dropdown if clicking outside nav (mobile-friendly)
  document.addEventListener('click', (e) => {
    if (!siteNav.contains(e.target)) {
      siteNav.classList.remove('open');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const siteNav = document.querySelector('.site-nav');
  const emptyTab = document.querySelector('.empty_tab_product');
  const path = window.location.pathname;

  if (!siteNav || !emptyTab) return;

  function isMobile() {
    return window.innerWidth < 850;
  }

  function updateEmptyTabVisibility() {
    // Only show if on /products/ AND on mobile
    if (path.includes('/products/') && isMobile()) {
      emptyTab.style.display = 'block'; // Overrides the CSS !important
    }
  }

  // Initial check
  updateEmptyTabVisibility();

  // Re-check on resize
  window.addEventListener('resize', updateEmptyTabVisibility);

  // Toggle dropdown when clicked
  emptyTab.addEventListener('click', (e) => {
    e.preventDefault();
    if (isMobile()) {
      siteNav.classList.toggle('open');
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (isMobile() && !siteNav.contains(e.target)) {
      siteNav.classList.remove('open');
    }
  });
});


  // JS for intro-overlay

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.querySelector("idle-overlay");
  const form = document.getElementById("comingSoonForm");

  if (!overlay || !form) return;

  const button = form.querySelector("button");
  const input = form.querySelector("input");

  const STORAGE_KEY = "frizbee_coming_soon";
  const THREE_HOURS = 3 * 60 * 60 * 1000;
  const now = Date.now();

  const saved = localStorage.getItem(STORAGE_KEY);
  const isThemeEditor = window.Shopify && Shopify.designMode;

  /* ---------- SKIP OVERLAY LOGIC ---------- */
  if (!isThemeEditor && saved && now - Number(saved) < THREE_HOURS) {
    overlay.remove();
    document.body.classList.remove("idle-locked");
    return;
  }

  /* ---------- SHOW OVERLAY ---------- */
  overlay.style.display = "block";
  overlay.style.opacity = "1";
  overlay.style.visibility = "visible";
  document.body.classList.add("idle-locked");

  /* ---------- FORM SUBMIT ---------- */
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (button.disabled) return;

    const email = input.value;

    // Visual feedback
    button.textContent = "THANK YOU";
    button.disabled = true;
    input.disabled = true;

    // Save to Shopify
    fetch("/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        "contact[email]": email,
        "contact[tags]": "collections-2026"
      })
    });

    // Save to Google Sheets via Make
    fetch("https://hook.eu2.make.com/svhcsynoeo45nkfv8vmibn7hm4n1jphi", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: email,
        source: "frizbee-ceramics-collection-2026-overlay",
        page_url: window.location.href,
        timestamp: new Date().toISOString()
      })
    });

    // Remember submission time
    localStorage.setItem(STORAGE_KEY, Date.now());

    // Fade out overlay
    setTimeout(() => {
      overlay.style.transition = "opacity 0.2s ease";
      overlay.style.opacity = "0";

      setTimeout(() => {
        overlay.remove();
        document.body.classList.remove("idle-locked");
      }, 200);
    }, 300);
  });
});

document.addEventListener("click", async function (e) {
    const btn = e.target.closest(".qty-btn");
    if (!btn) return;

    e.preventDefault();

    const wrapper = btn.closest(".cart-qty");
    const cart = document.querySelector("site-cart");

    if (!wrapper || !cart) return;

    let qty = parseInt(
        wrapper.querySelector(".qty-value").textContent,
        10
    );

    if (btn.classList.contains("qty-plus")) {
        qty = qty + 1;
    } else {
        qty = qty - 1; // allow 0 for removal
    }

    try {

        const response = await fetch(
            window.Shopify.routes.root + "cart/change.js?sections=header",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    id: wrapper.dataset.key,
                    quantity: qty
                })
            }
        );

        const data = await response.json();

        console.log("Cart updated:", data);


        // Update drawer HTML
        if (data.sections && data.sections.header) {
            cart.renderHTMLUpdate(data.sections.header);
        }


        // Close drawer if cart becomes empty
        if (data.items.length === 0) {
            cart.classList.remove("open");
            cart.classList.add("empty");
        } else {
            cart.classList.add("open");
            cart.classList.remove("empty");
        }


        // Notify Shopify/custom scripts
        document.dispatchEvent(
            new CustomEvent("cart:updated", {
                detail: data
            })
        );


    } catch (err) {
        console.error("Cart update error:", err);
    }
});




document.addEventListener("click", function (e) {
  const parentLink = e.target.closest(".parent-link");

  if (parentLink) {
    e.preventDefault();

    const menu = parentLink.closest(".header-inline-menu");
    menu.classList.toggle("active");
    return;
  }

  // Optional: Close when clicking outside
  document.querySelectorAll(".header-inline-menu.active").forEach(menu => {
    if (!menu.contains(e.target)) {
      menu.classList.remove("active");
    }
  });
});



document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".mobile-product-slider").forEach((slider) => {

    const track = slider.querySelector(".mobile-slider-track");
    const dots = slider.querySelectorAll(".dot");

    if (!track || dots.length <= 1) return;

    const updateDots = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });
    };

    track.addEventListener("scroll", () => {
      window.requestAnimationFrame(updateDots);
    });

    updateDots();
  });

});




document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('.site-nav.full-nav');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', function () {
    toggle.classList.toggle('active');
    menu.classList.toggle('menu-open');
  });
});




document.addEventListener('DOMContentLoaded', () => {
  // Select the main Add To Cart element
  const addToCartBtn = document.querySelector('.add-to-cart');

  // Add click listener to the Add To Cart element itself
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
     
      // Put your actual Add to Cart logic here
    });
  }

  // Select both bottom express buttons
  const expressButtons = document.querySelectorAll('.express-checkout-row .btn-express');

  // Trigger the main Add To Cart button when either express button is clicked
  expressButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent default button behavior
      
      if (addToCartBtn) {
        // Triggers the main Add To Cart button click event
        addToCartBtn.click();
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {

  const observer = new MutationObserver(function () {

    document.querySelectorAll('light-box').forEach(function (lightbox) {

      if (lightbox.querySelector('.custom-lightbox-close')) return;

      const closeButton = document.createElement('button');

      closeButton.className = 'custom-lightbox-close';
      closeButton.type = 'button';
      closeButton.setAttribute('aria-label', 'Close video');
      closeButton.innerHTML = '&times;';

      closeButton.addEventListener('click', function (e) {
        e.preventDefault();

        const video = lightbox.querySelector('video');

        if (video) {
          video.pause();
        }

        lightbox.remove();
      });

      lightbox.appendChild(closeButton);
    });

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const siteCart = document.querySelector("site-cart");
  const footerMarquee = document.querySelector(".footer-marquee");

  if (!siteCart) return;

  const toggleCartState = () => {
    const isOpen = siteCart.classList.contains("open");

    // Toggle body overflow
    document.body.classList.toggle("overflow", isOpen);

    // Toggle sticky class on footer marquee
    if (footerMarquee) {
      footerMarquee.classList.toggle("sticky", isOpen);
    }
  };

  // Set initial state
  toggleCartState();

  // Watch for class changes on <site-cart>
  const observer = new MutationObserver(toggleCartState);

  observer.observe(siteCart, {
    attributes: true,
    attributeFilter: ["class"],
  });
});




document.addEventListener('click', function (e) {
  const arrow = e.target.closest('.icon-menu-arrow');

  if (!arrow) return;

  const details = arrow.closest('.info-line.details');
  const moreDetails = details?.nextElementSibling;

  if (!moreDetails?.classList.contains('more-d')) return;

  arrow.classList.toggle('less');
  moreDetails.classList.toggle('show');
});